import Vue from 'vue'
// GeneralViews
import NotFound from 'src/pages/NotFoundPage.vue'
// Dashboard pages
import DashboardLayout from 'src/pages/admin/.Layout/DashboardLayout.vue'
import HomeTop from 'src/pages/admin/home/HomeTop.vue'
import MultiView from 'src/pages/admin/home/MultiView.vue'
import SingleView from 'src/pages/admin/home/SingleView.vue'
// Payouts page
import Payouts from 'src/pages/admin/Payouts.vue'
// Invoices page
import Invoices from 'src/pages/admin/Invoices.vue'
// Pages
import Login from 'src/pages/Login.vue'
import ChangePassword from 'src/pages/ChangePassword.vue'
import Register from 'src/pages/Register.vue'
import Lock from 'src/pages/Lock.vue'
import Version from 'src/pages/Version.vue'
// Setup
import Setup from 'src/pages/admin/Setup.vue'
//const Setup = () => import('src/pages/admin/Setup.vue')

// other
import store from '@/store/store'
import VueRouter from 'vue-router'
import { progress } from '../utils'

Vue.use(VueRouter)

const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/admin/home/multiview'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/changePassword',
      name: 'Change Password',
      meta: { requiresAuth: true },
      component: ChangePassword
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/lock',
      name: 'Lock',
      component: Lock
    },
    {
      path: '/admin',
      meta: { requiresAuth: true },
      component: DashboardLayout,
      redirect: '/admin/home/multiview',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: HomeTop,
          redirect: '/admin/home/multiview',
          children: [
            {
              path: 'singleview',
              name: 'Home',
              component: SingleView,
              beforeEnter (to, from, next) {
                if (store.getters.companySelected === 0) {
                  store.commit('SET_COMPANY_SELECTED', store.getters.companies.filter(c => !c.archived)[0])
                }
                next()
              }
            },
            {
              path: 'multiview',
              name: 'Home',
              component: MultiView,
              beforeEnter (to, from, next) {
                // console.log('!!!!!!!!!!beforeEnter multiView')
                if (store.getters.companies.filter(c => !c.archived).length > 1 && store.getters.companySelected != 0) {
                  store.commit('SET_COMPANY_SELECTED', 0)
                }
                next()
              }
            },
          ],
          async beforeEnter (to, from, next) {
            // console.log('!!!!!!!!! beforeEnter home')
            if (store.getters.isSetupComplete) {
              await store.dispatch('fetchData', { period: 'this month+', scope: 'home' })
            }
            next()
          }
        },
        {
          path: 'payouts',
          name: 'Payouts',
          component: Payouts,
          async beforeEnter (to, from, next) {
            if (store.getters.isSetupComplete) {
              await store.dispatch('fetchData', { period: 'this month+', scope: 'payouts' })
            }
            store.dispatch('fetchBaseData')
            next()
          }
        },
        {
          path: 'invoices',
          name: 'Invoices',
          component: Invoices,
          async beforeEnter (to, from, next) {
            if (store.getters.isSetupComplete) {
              await store.dispatch('fetchData', { period: 'this month+', scope: 'invoices' })
            }
            // store.dispatch('fetchBaseData')
            next()
          }
        },
        {
          path: 'setup',
          name: 'Setup',
          component: Setup,
          async beforeEnter (to, from, next) {
            await store.dispatch('fetchBaseData')
            next()
          }
        }
      ],
      async beforeEnter (to, from, next) {
        // console.log('!!!!!beforeEnter(/admin)')
        await store.dispatch('fetchBaseData')
        next()
      }
    },
    {
      path: '/404',
      name: '404',
      props: true,
      component: NotFound
    },
    {
      path: '*/v(ersion)?',
      name: 'App Version',
      meta: { requiresAuth: true },
      component: Version
    },
    {
      path: '*',
      redirect: {name: '404', params: {resourceType: 'page'}}
    }
  ]
})




// we check session validity before entering any secure page
router.beforeEach (async (to, from, next) => {
  console.log('beforeEach(): route requested = ', to.fullPath.toString())
  progress.start()
  progress.set(0.4)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // For protected routes, we make sure there is a token in the session
    const session = store.getters.session
    console.log('session: ', session)
    if (!!session && !!session.token) {
      // console.log('1')
      try { // we make sure the token is still valid
        // console.log('1.1')
        await store.dispatch('setToken', session.token)
        const isTokenValid = await store.dispatch('isSessionValid')
        if (isTokenValid) {
          // console.log('> router.beforeEach(): token valid')
          next()
        }
        else {
          console.log('> router.beforeEach(): token invalid')
          store.commit('CLEAR_SESSION')
          progress.done()
          next('/login')
        }
        
      }
      catch (error) { // we redirect to login if there was an issue
        store.commit('CLEAR_SESSION')
        progress.done()
        next('/login')
      }
    }
    else {
      console.log('2')
      // if (from.fullPath == to.fullPath) {
        progress.done()
      // }
      next('/login')
    }
  }
  else { // Unprotected routes
    // console.log('3')
    next()
  }
})

router.afterEach (() => {
  // console.log('afterEach():')
  progress.done()
})

export default router
